import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'age'
})
export class AgePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    const momentTocompare = moment("31-12-2026", "DD-MM-YYYY");
    // return moment().diff(moment(value), 'years');
    return momentTocompare.diff(moment(value), 'years');
  }

}
